import { render, staticRenderFns } from "./OrderBySelect.vue?vue&type=template&id=0dc63048"
import script from "./OrderBySelect.vue?vue&type=script&lang=ts"
export * from "./OrderBySelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports